export enum Units {
  deg = 'deg',
  kmph = 'km/h',
  meters = 'meters',
  mph = 'mph',
  mps = 'm/s',
  rpm = 'rpm',
  withoutUnit = '',
  yards = 'yards',
}

export type ParameterMediaType = 'Image' | '3DModel';

export type VideoUrlModel = {
  videoUrl: string;
  label: string;
};

export type LegendModel = {
  legendImageUrl: string;
  legendDescriptions: string;
};

export type ClubsScores = {
  driver: number | null;
  threeWood: number | null;
  fiveWood: number | null;
  hybrid: number | null;
  threeIron: number | null;
  fourIron: number | null;
  fiveIron: number | null;
  sixIron: number | null;
  sevenIron: number | null;
  eightIron: number | null;
  nineIron: number | null;
  pitchingWedge: number | null;
};

export type ParameterTourAveragesUnits = {
  deg: ClubsScores | null;
  kmph: ClubsScores | null;
  meters: ClubsScores | null;
  mph: ClubsScores | null;
  mps: ClubsScores | null;
  rpm: ClubsScores | null;
  withoutUnit: ClubsScores | null;
  yards: ClubsScores | null;
};

export type ParameterModel = {
  id: string;
  title: string;
  mediaType: string;
  mainImgUrl?: string | null;
  legendData?: LegendModel[] | null;
  threeDModelUrl?: string | null;
  definition?: string | null;
  usageInfo?: string | null;
  videoUrls: VideoUrlModel[];
  articlesInfo?: string | null;
  averageTourData?: ParameterAverageTourData | null;
};
export type ParameterPrimaryCategory = {
  [topic: string]: ParameterModel[];
};

export type ParametersList = {
  [key: string]: ParameterPrimaryCategory;
};

export type ParameterCategoryView = {
  id: string;
  title: string;
  subcategories: ParameterSubcategoryView[];
};

export type ParameterSubcategoryView = {
  id: string;
  title: string;
  parameters: ParameterModel[];
};

export type ParameterAverageTourData = {
  year: number;
  pga: ParameterTourAveragesUnits | null;
  lpga: ParameterTourAveragesUnits | null;
};

export type ParameterCategoryResponseV2 = {
  id: string;
  title: string;
  subcategories: ParameterSubcategoryResponseV2[];
};

export type ParameterSubcategoryResponseV2 = {
  id: string;
  title: string;
  parameters: ParameterResponseV2[];
};

export type ParameterLegendResponseV2 = {
  imageUrl: string;
  description: string;
};

export type ParameterResponseV2 = {
  id: string;
  title: string;
  mediaType: string;
  mainImgUrl?: string | null;
  threeDModelUrl?: string | null;
  legendItems: ParameterLegendResponseV2[];
  videos: VideoUrlModel[];
  definition?: string | null;
  usageInfo?: string | null;
  articlesInfo?: string | null;
  averageTourData?: ParameterAverageTourData | null;
};
